module.exports = __webpack_public_path__ + "fonts/rskhZa9Y.woff";